import {
    ADIMN_MANAGE_USER_START,
    ADIMN_MANAGE_USER_SUCCESS,
    ADIMN_MANAGE_USER_ERROR
} from "../Constants/MangeUserConstant"

const initialState = {
    loading: false,
    data: {},
};
export default function MangeUserReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case ADIMN_MANAGE_USER_START:
            return {
                ...state,
                loading: true,
            };
        case ADIMN_MANAGE_USER_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ADIMN_MANAGE_USER_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

